import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay } from 'swiper/modules';
import { breakpoints } from '../../utils/helpers'
import HomeSliderItem from './home-slider-item';
import Next from '-!svg-react-loader!../../assets/images/slide-arrow-next.svg';
import Prev from '-!svg-react-loader!../../assets/images/slide-arrow-prev.svg';

const HomeSlider = ({ slides }) => {
    const [hero, setHero] = useState(false);
    const [heroSwiper, setHeroSwiper] = useState(null);

    if (!slides) { return null }

    return (
        <section className="Home__slider">
            <div className="Home__slider__navigation">
                <button
                  className='Nav__button prev'
                  onClick={() => heroSwiper.slidePrev()}
                  aria-label='prev'
                >
                  <Prev />
                </button>
                <button
                  className='Nav__button next'
                  onClick={() => heroSwiper.slideNext()}
                  aria-label='next'
                >
                    <Next />
                </button>
            </div>
            <Swiper
                slidesPerView={1}
                spaceBetween={50}
                autoHeight={false}
                onSwiper={setHeroSwiper}
                autoplay={{ delay: 4000 }}
                modules={[Autoplay]}
                breakpoints={{
                    [breakpoints.md]: {
                        autoHeight: false
                    }
                }}
                onBeforeInit={swiper => setHero(swiper)}
            >
                {slides.map((slide, index) => (
                    <SwiperSlide className="Slide" key={index}>
                        <HomeSliderItem
                            slide={slide}
                            slideIndex={index}
                            slideCount={slides.length}
                            swiper={hero}
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    )
}

export default HomeSlider